var oReq = null;

const createTrobber = () => {
  const $ajax = document.createElement('div');
  $ajax.classList.add('ajax-progress');
  $ajax.classList.add('ajax-progress-fullscreen');

  const $trobbler = document.createElement('div');
  $trobbler.classList.add('ajax-throbber');
  $trobbler.classList.add('sk-three-bounce');

  for (var i = 0; i < 3; i++) {
    const $child = document.createElement('div');
    $child.classList.add('sk-child');
    $child.classList.add(`sk-bounce${i}`);
    $trobbler.appendChild($child);
  }

  $ajax.appendChild($trobbler);
  document.body.appendChild($ajax)
};

(function ($, Drupal, window, document) {

  'use strict';

  window.cancelDownload = () => {
    oReq.abort();
    $('#download-pdf').remove();
    const messages = new Drupal.Message();
    messages.add(Drupal.t('Download cancelled'), {type: 'status'});
  }


  const removeTrobber = () => {
    $('.ajax-progress.ajax-progress-fullscreen').remove();
  };

  // Disable dialog autofocus.
  $.ui.dialog.prototype._focusTabbable = function () {
  };

  // DMS
  Drupal.behaviors.dms = {

    attach: function (context, settings) {
      // ----------------
      // INPUT LABELS
      // ----------------
      $('.js-form-item').each((_, $el) => {
        const $input = $($el).find('input, textarea')[0];

        if ($input) {
          if ($input.value) {
            $el.classList.add('input-active');
          }

          $($input).on('focus input', _ => {
            $el.classList.add('input-active');
          })

          $input.addEventListener('blur', _ => {
            if (!$input.value) {
              $el.classList.remove('input-active');
            }
          })
        }
      });

      // ------------------
      // Single form submit
      // ------------------
      $(context).find('form:not([method="GET"])').once('single-submit').each(function () {
        $(this).on('submit', function (e) {
          let $button = $(this).find('input[type="submit"]');
          if (!$button.length) {
            return;
          }
          $button.attr('disabled', 'disabled');
        })
      });

      // ------------------
      // Tippy
      // ------------------
      tippy.setDefaults({
        arrow: true,
        delay: 40,
        theme: 'my-tippy',
        interactive: true,
      });
      tippy('[data-tippy-content]');


      // Add 'loading' to document search facet.
      $('.document-search--sidebar .facets-widget-checkbox li, .document-search--content .facet-state a').on('click', createTrobber);

      const onLangChange = function () {
        let $option = $(this).find(':selected');

        let path = settings.path.currentPath;
        let langcode = $option.val();

        document.location = settings.path.baseUrl + langcode + '/' + path;
      };

      $('.block-language .links').once('language-switcher').on('change', onLangChange);

      $('.block-language .links').once('set-language').val(settings.path.currentLanguage);

      // ----------------
      // PRODUCT SELECTOR
      // ----------------
      const $links = document.querySelectorAll('.product-selector-widget');
      Array.prototype.slice.call($links).forEach(function (element) {
        $select.addEventListener('change', e => {
          createTrobber();
          const url = e.currentTarget.value; // get selected value
          if (url) {
            document.location.href = url, true;
          } // redirect
          return false;
        })
      });

      // Set active option
      $($links).find('option').each((_, $el) => {
        if ($el.classList.contains('is-active')) {
          $links.value = $el.value;
        }
      });

      // Be carefull when editing stuff below!

      // Mobile menu
      $('.js-mm-toggle').once().click(function (e) {
        $('body').toggleClass('mm-open');
        e.preventDefault();
      });

      // Tracking
      $('a[href^="mailto:"]').addClass('gtm-mail');
      $('a[href^="tel:"]').addClass('gtm-phone');

    }


    // $("a[data-dialog-type='modal']").on('click', e => {
    //   // console.log(e.currentTarget);
    //   $('body').addClass('ui-modal--isOpen')
    // })

  };

})(jQuery, Drupal, window, document);
